// AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getMe().then(r => setUser(r.data)).catch(() => localStorage.removeItem('token')).finally(() => setLoading(false));
    } else setLoading(false);
  }, []);

  const loginUser = (token, userData) => { localStorage.setItem('token', token); setUser(userData); };
  const logout = () => { localStorage.removeItem('token'); setUser(null); };
  const updatePontos = (pontos) => setUser(u => u ? { ...u, pontos } : u);

  return <AuthContext.Provider value={{ user, loading, loginUser, logout, updatePontos }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
